import styled from '@emotion/styled'

import { SearchProductIcon } from '../icons'
import { LinkButton } from 'ui/inputs/Button'

export const ApplySection = (): JSX.Element => (
	<Background>
		<SearchProductIcon />
		<h2 style={{ marginTop: '24px' }}>Let Fiona match you with the right financial product offers</h2>
		<p style={{ padding: '24px 0', maxWidth: '420px' }}>Our service is free and will NOT affect your credit score</p>
		<LinkButton href={'/search/new'}>Get Started</LinkButton>
	</Background>
)

const Background = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	text-align: center;
	padding: 70px 20px;
	background: #f9f2ff;
`
